import { render, staticRenderFns } from "./tempcharts.vue?vue&type=template&id=52df9d88&scoped=true&"
import script from "./tempcharts.vue?vue&type=script&lang=js&"
export * from "./tempcharts.vue?vue&type=script&lang=js&"
import style0 from "./tempcharts.vue?vue&type=style&index=0&id=52df9d88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52df9d88",
  null
  
)

export default component.exports